import { ClientTypeAttributes, Color } from '@/types'
import { CreateClientTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateClientTypeMutation, ClientTypeAttributes, never, never>({
    defaultValues: {
      name: '',
      color: Color.Red
    },
    mutation: CreateMutation,
    resultKey: 'createClientType',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      { formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
